import * as React from "react"
import {SwitchSeeker} from "@ui-seeker/core"
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {repricingAlerts} from "../../../@signals";


export default function RepricingAlertCardAction({ enabled, alertID, idx }) {
	return <SwitchSeeker
		formControlProps={{ sx: { m: 0 } }}
		checked={enabled}
		onChange={e => postSubmit(`${BACKEND_APIS.REPRICING}/enabled`, { ruleID: alertID, enabled: e.target.checked ? 1 : 0 }).then(res => {
			repricingAlerts.value[idx] = {...repricingAlerts.value[idx], ...res}
			repricingAlerts.value = [...repricingAlerts.value]
		})}
	/>
}